export default __webpack_public_path__ + "tab3_video_poster_m065bf6.png";